import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ContactRow } from "../dashboard-components/ContactRow";
import { CardHeader } from "../../../components/CardHeader";

export const DashboardContactSection = () => {
  return (
    <div className="card">
      <CardHeader title="HeapsGo contact" />
      <div className="card-body d-flex flex-column" style={{ gap: "16px" }}>
        <ContactRow
          icon={<FontAwesomeIcon icon={solid("phone")} />}
          text="+45 30 20 16 20"
        />
        <ContactRow
          icon={<FontAwesomeIcon icon={solid("envelope")} />}
          text="partner@heapsgo.com"
        />
        <ContactRow
          icon={<FontAwesomeIcon icon={solid("location-dot")} />}
          text="Frederiksberggade 3A, 1459 København"
        />
      </div>
    </div>
  );
};
